import { useEffect } from "react";
import SchemaCardView from "./SchemaCardView";


const SchemaOverview = (props) => {
  return (
    <>
      <SchemaCardView
        title="Schemas"
        tag="schemas"
        schema={props.schema}
      />
    </>
  );
};

export default SchemaOverview;
